import React from 'react';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';

const Drawer = (props) => {
  const { isOpen, heading, children, toggle, ...rest } = props;
  return (
    <Offcanvas direction="end" className="right-drawer" isOpen={isOpen}>
      <OffcanvasHeader toggle={toggle}>{heading}</OffcanvasHeader>
      <OffcanvasBody>{children}</OffcanvasBody>
    </Offcanvas>
  );
};

export default Drawer;
